<!--
* @Name：待办
* @Author: 刘玉
* @Date: 2021-12-02 10:47:19
* @Last Modified by: 刘玉
* @Last Modified time: 2021-12-02 10:47:19
-->
<template>
  <div class="container">
    <van-nav-bar
      title="待办"
      left-arrow
      left-text="返回"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :fixed="true"
    >
      <template #right>
        <van-icon name="search" size="20" color="#323233" />
      </template>
    </van-nav-bar>
    <van-pull-refresh class="todo-list" v-model="loading" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-swipe-cell v-for="item in list" :key="item.id">
          <div class="todo-item" @click="toApproval(item)">
            <div class="todo-item-left">
              <div class="todo-item-title">
                <van-icon name="todo-list-o" color="#1989fa" />&nbsp;
                <span>{{ item.subject.match(/发起了(\S*)流程/)[1] }}</span>
              </div>
              <div class="todo-item-content">
                <van-row v-for="el in todoItem" :key="el.prop">
                  <van-col :span="8" class="todo-item-content-name">{{ el.name }}</van-col>
                  <van-col :span="16" class="todo-item-content-value">{{ item[el.prop] }}</van-col>
                </van-row>
              </div>
            </div>
            <div class="todo-item-right">
              <div class="todo-item-right-child">
                <van-icon name="arrow" color="#000000" />
              </div>
            </div>
          </div>
        </van-swipe-cell>
      </van-list>
    </van-pull-refresh>
    <van-action-sheet v-model="queryVisible" title="查询条件">
      <div class="search-box">
        <van-field v-model="query.subject" label="标题" />
        <van-field v-model="query.keyWord" label="流程名称" />
        <van-field v-model="query.startUserName" label="发起人" />
        <van-button type="info" size="small" icon="search" block style="margin-top: 20px" @click="search"
          >查询</van-button
        >
        <van-button type="danger" size="small" icon="delete" block style="margin-top: 15px" @click="reset"
          >清空</van-button
        >
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import { getTodos } from '@/api/process'
import Bridge from '@/components/dsbridge.js'
export default {
  name: 'Todo',
  data() {
    return {
      pathMaps: {
        statementAccountDetail: '/accountOrderApproval', // 对账单审批
        AddPmPriceBargain: '/bargainApproval', // 议价审批
        paymentInitial: '/payApproval', // 付款申请流程
        purOrderIssueDetail: '/poApproval', // 采购订单下达审批
        changeDetail: '/pomApproval', // 采购订单变更审批
        approvalPurchaseDetail: '/prApproval', // 采购申请审批
        coopCrossOrgAllotHeadDetailed: '/cotApproval', // 跨组织调拨审批
        SupplierIdentificationApplyForm: '/supplierApplyApproval', // 供应商认定申请审批
        factoryAuditReportUpload: '/supplierResultApproval' // 供应商认定结果审批
      },
      todoItem: [
        {
          name: '流程标题：',
          prop: 'subject'
        },
        {
          name: '发起用户：',
          prop: 'startUserName'
        },
        {
          name: '到达时间：',
          prop: 'createTime'
        },
        {
          name: '当前节点：',
          prop: 'name'
        }
      ],
      list: [],
      total: 0,
      loading: false,
      refreshing: false,
      finished: false,
      queryVisible: false,
      query: {
        subject: undefined,
        keyWord: undefined,
        startUserName: undefined,
        page: 0,
        limit: 10
      }
    }
  },
  methods: {
    onClickLeft() {
      Bridge.callMethodSyn('app.jsLeavePage', '')
    },
    onClickRight() {
      this.queryVisible = true
    },
    async search() {
      this.queryVisible = false
      await this.onRefresh()
    },
    reset() {
      this.query = {
        subject: undefined,
        keyWord: undefined,
        startUserName: undefined,
        page: 0,
        limit: 10
      }
    },
    async onRefresh() {
      this.finished = false
      this.query.page = 0
      this.list = []
      this.loading = true
      await this.onLoad()
    },
    async onLoad() {
      this.query.page++
      try {
        const response = await getTodos(this.query)
        if (response && response.success) {
          this.list.push(...response.data.rows)
          this.total = Number(response.data.total)
          this.finished = this.list.length === this.total
        } else {
          this.finished = true
        }
      } catch (e) {
        console.error(e)
        this.finished = true
      } finally {
        this.loading = false
      }
    },
    toApproval(item) {
      // this.$store
      //   .dispatch('workflow/openApproval', {
      //     taskId: item.id,
      //     businessKey: item.businessKey,
      //     taskDefinitionKey: item.taskDefinitionKey
      //   })
      //   .then(() => {
      //     console.log('key---------' + item.formValue)
      //      this.$router.push('/pomApproval')
      //   })
      this.$router.push({
        name: 'purchaseContractChangeApproval',
        query: {
          taskId: item.id,
          businessKey: item.businessKey,
          taskDefinitionKey: item.taskDefinitionKey
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  height: 100%;
}
.todo-list {
  margin-top: 48px;
}
.search-box {
  padding: 16px 16px 50px;
}
.todo-item {
  display: flex;
  border-bottom: 2px solid #ebedf0;
  padding: 10px 0;
}
.todo-item-left {
  width: 95%;
  .todo-item-title {
    padding: 0 10px 10px 10px;
    border-bottom: 1px solid #ebedf0;
    color: #000000;
    font-size: 15px;
  }
  .todo-item-content {
    .todo-item-content-name {
      text-align: right;
      color: #909399;
      font-size: 15px;
    }
    .todo-item-content-value {
      color: #000000;
      font-size: 15px;
    }
  }
  .van-row {
    padding: 5px 0;
  }
}
.todo-item-right {
  width: 5%;
  padding-right: 10px;
  .todo-item-right-child {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}
</style>
